module.exports = __webpack_public_path__ + "assets/img/tishi.a1e7c3eb.png";